import { createRequestActionTypes } from '../../helpers'

export const FETCH_RELATED = createRequestActionTypes(
  'RELATED_SIDEBAR',
  'RELATED'
)
